import { React, useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import { FocusError } from "focus-formik-error";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { updateLoader } from "../../../_redux/LoaderSlice";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import GetJobId from "../../../_utilities/GetJobId";
import DynamicTable from "../../../components/DynamicTable/DynamicTable";
import Pagination from "../../../components/DynamicTable/Pagination";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import "./HiringManagers.css";
import HiringManagerCard from "./HiringManagerCard";
import * as _ser from "../../../_redux/_services/ClientsSlice";
import { DashboardPlusicon } from "../../../../src/Icons/DashboardPlusicon";
import { HiringManagerIcon } from "../../../Icons/HiringManagerIcon";
import WarningPopup from "../../../components/WarningPopup/WarningPopup";

const initalState = { data: null, message: "", isloader: true };

const HiringManagers = () => {
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [hiringManagers, setHiringManagers] = useState([]);
  const [config, setConfig] = useState(configuration);
  const [filterValue, setFilterValue] = useState("");
  const [selectedManager, setSelectedManager] = useState("");
  const [isHiringmanagersEdit, setIsHiringmanagersEdit] = useState(false);
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  let getJobCode = GetJobId();

  const HiringManagersForm = JSON.parse(JSON.stringify(iniValues));

  const initialPayload = { limit: config.limitData, offset: 1, keyword: "" };

  const hiringManagersList = useSelector(
    (state) => state.GetHiringManagers.data?.data,
  );

  useEffect(() => {
    fetchData(initialPayload);
  }, []);

  const fetchData = async (obj) => {
    setHiringManagers([]);
    dispatch(_ser.getHiringmanagersAsync(getJobCode, obj));
  };

  useEffect(() => {
    if (hiringManagersList) {
      let data = JSON.parse(JSON.stringify(hiringManagersList));
      data?.rows?.forEach((item) => {
        item["isChecked"] = false;
      });
      config.totalRecords = hiringManagersList.total_count;
      config.currentPage =
        hiringManagersList.total_count > config.recordperPage
          ? config.currentPage
          : 1;
      setHiringManagers(data?.rows || []);
      dispatch(_ser.getHiringmanagersStartReducer(initalState));
    }
  }, [hiringManagersList]);

  const getSearchResult = async (object, paging, type) => {
    if (paging === true) {
      let value = object.keyword ? object.keyword : filterValue;
      setFilterValue(value);
      object["keyword"] = value;
      if (type === "searchResult") {
        object["offset"] = 1;
        object["limit"] = config.limitData;
        dispatch(_ser.getHiringmanagersAsync(getJobCode, object));
      }
    } else {
      setFilterValue(object.keyword);
    }
  };

  // for dynamic component received props
  const onReceiveActionHandler = async (type, object) => {
    if (type === "pagination") {
      if (filterValue !== "") {
      } else {
        let configure = JSON.parse(JSON.stringify(config));
        configure.currentPage = object.current;
        setConfig(configure);
        let obj1 = {
          limit: config.limitData,
          offset:
            object.current !== 1
              ? (object.current - 1) * config.limitData + 1
              : object.current,
          keyword: "",
        };
        fetchData(obj1);
      }
    } else if (type === "searchResult") {
      getSearchResult(object, true, "searchResult");
    } else if (type === "cancelSearchResult") {
      setFilterValue("");
      fetchData(initialPayload);
    } else if (type === "pageRange") {
      setConfig({
        ...config,
        limitData: (config.limitData = object),
        recordperPage: object,
      });
      let validPage = config.totalRecords > object ? config.currentPage : 1;
      let obj1 = {
        current: validPage,
        offset:
          validPage !== 1 ? (validPage - 1) * config.limitData + 1 : validPage,
        limit: config.limitData,
        keyword: object.keyword || filterValue || "",
      };
      fetchData(obj1);
    } else if (type === "detailspage") {
      setIsRightSidePannel(true);
      setIsHiringmanagersEdit(true);
      let managerObj = {
        id: object.id,
        fullName: object.fullName || "",
        jobTitle: object.jobTitle || "",
        emailId: object.emailId || "",
        contactNumber: object.contactNumber || "",
      };
      setSelectedManager(managerObj);
    } else if (type === "confirmDel") {
      // deleteRecords(object);
      setSelectedManager(object);
      setDeletePopupOpen(true);
    }
  };

  const handleDeleteJob = () => {
    deleteRecords(selectedManager);
    setDeletePopupOpen(false);
  };

  const deleteRecords = async (object) => {
    let managerId;
    if (typeof object === "object" && object.length > 0) {
      managerId = object.map((x) => x.id.toString());
    } else {
      managerId = [object.id.toString()];
    }
    let obj = { managerId: managerId };
    dispatch(_ser.deleteHiringmanagersAsync(getJobCode, obj));
    setTimeout(() => {
      fetchData(initialPayload);
    }, 2000);
  };

  const onReceivePropsHandler = (pannel, load) => {
    setIsRightSidePannel(pannel);
    if (load === "fetch") {
      fetchData(initialPayload);
    }
  };

  const AddNewHandler = (type, data) => {
    setIsRightSidePannel(true);
    setSelectedManager("");
    setIsHiringmanagersEdit(false);
  };

  return (
    <>
      <div
        className="addMangersection"
        style={{ display: "flex", height: "34px", gap: "10px" }}
        onClick={() => AddNewHandler("Create", " ")}
      >
        <DashboardPlusicon width={35} height={36} />
        {/* <img src={process.env.PUBLIC_URL + "/assests/img/Group 2196.png"} alt="" /> */}
        <p className="addnewManagertext">Add Hiring Manager</p>
      </div>

      <div className="hiring-managers-container">
        {hiringManagers?.length > 0 ? (
          <div className="hiring-managers-grid">
            {hiringManagers.map((manager, index) => (
              <HiringManagerCard
                key={manager.id || index}
                manager={manager}
                onClick={(type, obj) => onReceiveActionHandler(type, obj)}
              />
            ))}
          </div>
        ) : (
            <div className="detail-card-empty">
              <img
                src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                alt="No data"
              />
              No hiring managers found
            </div>
        )}
        {hiringManagers?.length > 0 && (
          <div className="pagination-wrapper">
            <Pagination
              currentPage={config.currentPage}
              totalCount={config.totalRecords}
              pageSize={config.limitData}
              onPageChange={(page) =>
                onReceiveActionHandler("pagination", { current: page })
              }
            />
          </div>
        )}
      </div>

      <div className="Hiringmanagersrightsidebar">
        {isRightSidePannel ? (
          <RightSideBar
            componentData={
              <ComponentRenderData
                componentType={
                  isHiringmanagersEdit
                    ? "EditHiringManagers"
                    : "AddHiringmanagers"
                }
                onReceivechildProps={onReceivePropsHandler}
                getJobCode={getJobCode}
                input={
                  isHiringmanagersEdit ? selectedManager : HiringManagersForm
                }
              />
            }
            componentLayout={pannelobj}
            onReceiveProps={onReceivePropsHandler}
          />
        ) : (
          ""
        )}
      </div>

      <WarningPopup
        open={deletePopupOpen}
        handleClose={() => setDeletePopupOpen(false)}
        handleConfirm={handleDeleteJob}
        details={{
          title: "Are you sure you want to delete this hiring manager?",
          btnName: "Delete",
        }}
      />
    </>
  );
};

const ComponentRenderData = ({
  onReceivechildProps,
  componentType,
  getJobCode,
  input,
}) => {
  const [hiringManagersDetails, setHiringManagersDetails] = useState(input);
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);

  const dispatch = useDispatch();

  const addHiringManagerRes = useSelector(
    (state) => state.AddHiringManagers.data,
  );
  const editHiringManagerRes = useSelector(
    (state) => state.EditHiringmanagers.data,
  );
  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  useEffect(() => {
    if (addHiringManagerRes === 200) {
      onReceivechildProps(false, "fetch");
      dispatch(_ser.addHiringmanagersStartReducer(initalState));
    }
  }, [addHiringManagerRes]);

  useEffect(() => {
    if (editHiringManagerRes === 200) {
      onReceivechildProps(false, "fetch");
      dispatch(_ser.editHiringmanagersStartReducer(initalState));
    }
  }, [editHiringManagerRes]);

  const handleChange = (event) => {
    let { name, value } = event.target;
    if (name === "emailId") {
      value = value.toLowerCase();
      value = value.trim();
    }
    if (name === "contactNumber") {
      value = value.replace(/\D/g, "");
    }
    formik.values[name] = value;
    setHiringManagersDetails((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  useEffect(() => {
    console.log("hiringManagersDetails", hiringManagersDetails);
  }, [hiringManagersDetails]);

  const validRegex = /^[a-zA-Z0-9_!#$%&*+/=?`{}~^.-]+@[a-zA-Z0-9.-]+$/;
  const phoneRegExp = /^[0-9()+-\s\b]*$/;

  const validationSchema = Yup.object({
    fullName: Yup.string()
      .min(2, "Must be min 2 characters")
      .max(20, "Must be less than 20 ")
      .required("Please enter full name"),
    jobTitle: Yup.string().nullable().required("Please enter job title"),
    emailId: Yup.string()
      .email("Please enter E-mail address")
      .matches(validRegex, "Invalid E-mail address")
      .required("Please enter E-mail address"),
    contactNumber: Yup.string()
      .matches(
        phoneRegExp,
        "Invalid contact number format. Please enter a valid number",
      )
      .min(10, "must be 10 characters")
      .max(20, "must be less than 20")
      .required("Please enter contact number"),
  });

  const formik = useFormik({
    initialValues: input,
    validationSchema,
    onSubmit: async (value) => {
      try {
        if (componentType !== "EditHiringManagers") {
          await dispatch(
            _ser.addHiringmanagersAsync(getJobCode, hiringManagersDetails),
          );
        } else {
          await dispatch(
            _ser.editHiringmanagersAsync(
              getJobCode,
              hiringManagersDetails,
              hiringManagersDetails.id,
            ),
          );
        }
      } catch (err) {
        console.error("Submission error:", err);
      } finally {
        setDisableSubmitBtn(false);
      }
    },
  });

  return (
    <div
      className="hiring-manager-form-container"
      style={{
        "--primary-bg-color": storedTheme?.primaryColor,
        "--primary-font-color": storedTheme?.primaryFontColor,
      }}
    >
      <div className="hiring-manager-form-content">
        <div className="groupfields">
          <HiringManagerIcon
            primaryColor={storedTheme?.primaryColor}
            primaryFontColor={storedTheme?.primaryFontColor}
          />
          <FocusError formik={formik} />
          <div
            style={{
              display: "flex",
              marginTop: "40px",
              gap: "25px",
            }}
          >
            <div style={{ width: "48%" }}>
              <TextField
                className="boldlabelvendor"
                id=""
                label="Full Name* &nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="fullName"
                value={hiringManagersDetails.fullName}
                onChange={handleChange}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                error={
                  formik.errors.fullName && formik.touched.fullName
                    ? true
                    : false
                }
                helperText={
                  formik.errors.fullName && formik.touched.fullName
                    ? formik.errors.fullName
                    : ""
                }
              />
            </div>

            <div style={{ width: "48%" }}>
              <TextField
                className="boldlabelvendor"
                id=""
                label="Job Title* &nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="jobTitle"
                value={hiringManagersDetails.jobTitle}
                onChange={handleChange}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                error={
                  formik.errors.jobTitle && formik.touched.jobTitle
                    ? true
                    : false
                }
                helperText={
                  formik.errors.jobTitle && formik.touched.jobTitle
                    ? formik.errors.jobTitle
                    : ""
                }
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              marginTop: "30px",
              gap: "25px",
            }}
          >
            <div style={{ width: "48%" }}>
              <TextField
                className="boldlabelvendor"
                id=""
                label="E-mail Address* &nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="emailId"
                value={hiringManagersDetails.emailId}
                onChange={handleChange}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                error={
                  formik.errors.emailId && formik.touched.emailId ? true : false
                }
                helperText={
                  formik.errors.emailId && formik.touched.emailId
                    ? formik.errors.emailId
                    : ""
                }
              />
            </div>
            <div style={{ width: "48%" }}>
              <TextField
                className="boldlabelvendor"
                id=""
                label="Contact Number* &nbsp;"
                variant="outlined"
                style={{ width: "100%" }}
                name="contactNumber"
                value={hiringManagersDetails.contactNumber}
                onChange={handleChange}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                error={
                  formik.errors.contactNumber && formik.touched.contactNumber
                    ? true
                    : false
                }
                helperText={
                  formik.errors.contactNumber && formik.touched.contactNumber
                    ? formik.errors.contactNumber
                    : ""
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div className="hiring-manager-form-footer">
        <Button
          className="hiring-manager-cancel-btn"
          onClick={() => onReceivechildProps(false)}
        >
          Cancel
        </Button>
        <Button
          className="hiringmanagersaveBtn"
          variant="contained"
          disableSubmitBtn={disableSubmitBtn}
          onClick={formik.handleSubmit}
        >
          {componentType === "EditHiringManagers" ? "Update" : "Save"}
        </Button>
      </div>
    </div>
  );
};
export default HiringManagers;

const pannelobj = {
  title: "Add Hiring Manager",
  description: "",
  bgImage: "",
};

// for dynamic Table config Object
const configuration = {
  isSearchbar: true,
  isPaging: true,
  isDropdownActions: true,
  isCheckbox: true,
  isActions: false,
  recordperPage: 9,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: "",
  limitData: 9,
  isCheckAlignRight: true,
  isPaginationTop: false,
  isSearchServer: true,
  isPagingServer: true,
  isPageRange: true,
};

// for dynamic Table Action dropdownData
const actionsDropdownData = ["Delete"];

// for dynamic Table row Action buttons
const actionsList = {
  isDownload: false,
  isDelete: false,
};

const iniValues = {
  fullName: "",
  jobTitle: "",
  emailId: "",
  contactNumber: "",
};

// for dynamic Table Headers and columns
const columnsData = [
  {
    id: 1,
    displayName: "First Name",
    mappingName: "firstName",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: " dynatablebodytext text-center ",
    type: "clients",
    width: "",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 2,
    displayName: "Last Name",
    mappingName: "lastName",
    theadClass: "dynatableheadtext text-center ",
    tbodyClass: " dynatablebodytext text-center",
    type: "clients",
    width: "",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 3,
    displayName: "E-mail ID",
    mappingName: "emailId",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: " text-center",
    type: "clients",
    width: "",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 4,
    displayName: "Contact Number",
    mappingName: "contactNumber",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: " text-center",
    type: "clients",
    width: "",
    isEdit: true,
    nagigate: "detailspage",
  },
];
